import { render, staticRenderFns } from "./InfoChain.vue?vue&type=template&id=f2034988&scoped=true&"
import script from "./InfoChain.vue?vue&type=script&lang=js&"
export * from "./InfoChain.vue?vue&type=script&lang=js&"
import style0 from "./InfoChain.vue?vue&type=style&index=0&id=f2034988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2034988",
  null
  
)

export default component.exports